@use "foundation/_colors.scss";

.org-options {
  margin: 2.5em 0;

  a.contact-us {
    text-decoration: underline;
    color: colors.$primary-text-color;
  }
}

.org-plan {
  display: flex;

  .tier-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 24%;
    padding: 0.5em;
    border-radius: .5em;
    text-align: center;
    background-color: colors.$primary-text-color;
    color: white;

    li {
      margin: 1em
    }

    .tier-card-content {
      width: 100%;
      h4 {
        margin: 0;
      }

      .tier-card-divider {
        background-color: white;
        height: .1em;
        width: 25%;
        margin: .75em auto;
      }
    }
    &+.tier-detail {
      margin-left: 1.25em;
    }
  }

  div.tier-detail {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 35%;

    a.pricing {
      text-decoration: underline;
      color: colors.$primary-text-color;
    }

    a.sales {
      margin: unset;
    }
  }
}
